import { render, staticRenderFns } from "./SiteDetail.vue?vue&type=template&id=3c6374a1&scoped=true"
import script from "./SiteDetail.vue?vue&type=script&lang=js"
export * from "./SiteDetail.vue?vue&type=script&lang=js"
import style0 from "./SiteDetail.vue?vue&type=style&index=0&id=3c6374a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6374a1",
  null
  
)

export default component.exports